import React, { Component } from 'react';

// 68) We can even create a link to a path with URL Params. Let's add one here to the bottom of the home component. First thing we need to do is import the 'link' component ...

import { Link } from 'react-router-dom';

// class Home extends Component {
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//       </div>
//     );
//   }
// }

// 69) Then right below the <hr/> we add an <h3> for featured teachers. Followed below with 'Link' tags. Fill in the path in the "to" attribute. See below then ((go to App.js))

// class Home extends Component {
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul">John Doe</Link>
//         <Link to="teachers/CSS/Jane">Jane Doe</Link>
//       </div>
//     );
//   }
// }

// 72) Now in our home page links we can add the full name in the path. Now we will see the full name on the page as well as in the URL ...

// 73) You can also make parameters in a route optional but we won't cover that in this tutorial.

// class Home extends Component {
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//       </div>
//     );
//   }
// }

// 74) There may be times when you want to programatically change the path in the URL. Here we will change the path in response to a form submission. We will navigate to a URL in response to the values typed into a form. So first let's add the form to the "Home" component.

// class Home extends Component {
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//
//         <form>
//           <input type="text" placeholder="Name" />
//           <input type="text" placeholder="Topic" />
//           <button type="submit">Go!</button>
//         </form>
//
//       </div>
//     );
//   }
// }

// 75) Now we add a new function in the "Home" component, just above the render method, called "handleSubmit". This function is going to get the values in the form inputs and insert them into the URL when the user submits the form. We add the event object to the function paramemters, then we call "e.preventDefault();" to keep the form from submitting to itself on submission.

// class Home extends Component {
//
//   handleSubmit = (e) => {
//     e.preventDefault();
//     let teacherName = this.name.value;
//     let teacherTopic = this.topic.value;
//   }
//
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//
//         <form>
//           <input type="text" placeholder="Name" />
//           <input type="text" placeholder="Topic" />
//           <button type="submit">Go!</button>
//         </form>
//
//       </div>
//     );
//   }
// }

// 76) Next we get the input variables and store them in variables. THese input variables come from the inputs ...

// class Home extends Component {
//
//   handleSubmit = (e) => {
//     e.preventDefault();
//     let teacherName = this.name.value;
//     let teacherTopic = this.topic.value;
//   }
//
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//
//         <form>
//           <input type="text" placeholder="Name" />
//           <input type="text" placeholder="Topic" />
//           <button type="submit">Go!</button>
//         </form>
//
//       </div>
//     );
//   }
// }

// 77) Now we use refs in the inputs to access the values in the input fields. We need to to get the values into "this.name.value" and "this.topic.value". In React refs allow you to reference, or, get direct access to a dom element. We now add a ref attribute to both input elements.

// class Home extends Component {
//
//   handleSubmit = (e) => {
//     e.preventDefault();
//     let teacherName = this.name.value;
//     let teacherTopic = this.topic.value;
//   }
//
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//
//         <form>
//           <input type="text" placeholder="Name" ref={} />
//           <input type="text" placeholder="Topic" ref={} />
//           <button type="submit">Go!</button>
//         </form>
//
//       </div>
//     );
//   }
// }

// 78) The ref attribute takes a callback function that recieves the underlying DOM element as it's argument. Then into this.name and this.topic we place the object that holds the inputs value (input) from the input field. Back up top in the handleSubmit function we can access the value in the handleSubmit function through this.name.value and this.topic.value.

// class Home extends Component {
//
//   handleSubmit = (e) => {
//     e.preventDefault();
//     let teacherName = this.name.value;
//     let teacherTopic = this.topic.value;
//   }
//
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//
//         <form>
//           <input type="text" placeholder="Name" ref={(input) => this.name = input} />
//           <input type="text" placeholder="Topic" ref={(input) => this.topic = input} />
//           <button type="submit">Go!</button>
//         </form>
//
//       </div>
//     );
//   }
// }

// 79) Now in the handleSubmit function to create the path that will be inserted into the URL we will use a JS template literal to combine the values of teacherTopic and TeacherName into a variable called path.

// 80) Now if you had previously removed this route <Route path="/teachers/:topic/:name" component={Featured} /> from the App component, be sure to go back thert and add it again. view below then go to (( Featured.js ))

// class Home extends Component {
//
//   handleSubmit = (e) => {
//     e.preventDefault();
//     let teacherName = this.name.value;
//     let teacherTopic = this.topic.value;
//     let path = `teachers/${teacherTopic}/${teacherName}`;
//   }
//
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//
//         <form>
//           <input type="text" placeholder="Name" ref={(input) => this.name = input} />
//           <input type="text" placeholder="Topic" ref={(input) => this.topic = input} />
//           <button type="submit">Go!</button>
//         </form>
//
//       </div>
//     );
//   }
// }

// 82) Now we push the value of path into the history stack. This will redirect the user to the URL stored in 'path'. and add it to the histry so that the back and forward button work approprietly.

// class Home extends Component {
//
//   handleSubmit = (e) => {
//     e.preventDefault();
//     let teacherName = this.name.value;
//     let teacherTopic = this.topic.value;
//     let path = `teachers/${teacherTopic}/${teacherName}`;
//     this.props.history.push(path);
//   }
//
//   render() {
//     return (
//       <div className="main-content home">
//         <h2>Front End Course Directory</h2>
//         <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
//         <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
//         <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
//         <hr />
//         <h3>Featured Teachers</h3>
//         <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
//         <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
//         <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>
//
//         <form>
//           <input type="text" placeholder="Name" ref={(input) => this.name = input} />
//           <input type="text" placeholder="Topic" ref={(input) => this.topic = input} />
//           <button type="submit">Go!</button>
//         </form>
//
//       </div>
//     );
//   }
// }

// 83) The last thing we need to do is connect up the form's onSubmit handler function. "this.handleSubmit"

class Home extends Component {

  handleSubmit = (e) => {
    e.preventDefault();
    let teacherName = this.name.value;
    let teacherTopic = this.topic.value;
    let path = `teachers/${teacherTopic}/${teacherName}`;
    this.props.history.push(path);
  }

  render() {
    return (
      <div className="main-content home">
        <h2>Front End Course Directory</h2>
        <p>This fun directory is a project for the <em>React Router Basics</em> course on Treehouse.</p>
        <p>Learn front end web development and much more! This simple directory app offers a preview of our course library. Choose from many hours of content, from HTML to CSS to JavaScript. Learn to code and get the skills you need to launch a new career in front end web development.</p>
        <p>We have thousands of videos created by expert teachers on web design and front end development. Our library is continually refreshed with the latest on web technology so you will never fall behind.</p>
        <hr />
        <h3>Featured Teachers</h3>
        <Link to="teachers/HTML/Peter-Mingione">Peter Mingione</Link>
        <Link to="teachers/Javascript/Paul-Doe">John Doe</Link>
        <Link to="teachers/CSS/Jane-Doe">Jane Doe</Link>

        <form onSubmit={this.handleSubmit}>
          <input type="text" placeholder="Name" ref={(input) => this.name = input} />
          <input type="text" placeholder="Topic" ref={(input) => this.topic = input} />
          <button type="submit">Go!</button>
        </form>

      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js